import { Module } from "vuex";

import { RootStateType } from "@/store";

import actions from "./actions";
import mutations from "./mutations";
import { CalendarState } from "./model";

let state: CalendarState = {
  calendars: [],
  calendar: {
    id: '',
    terminalId: '',
    name: '',
    description: '',
    startDate: '',
    recurrenceTimeZone: 'Etc/UTC',
    daysOfWeek: null,
    weeksOfMonth: null,
    interval: null,
    intervalType: null,
    endDate: null,
    numberOfOccurrences: null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
} as Module<CalendarState, RootStateType>;
